//import logo from './logo.svg';
import './App.css';

import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ExerciseMainPage from './pages/ExerciseMainPage/ExerciseMainPage';
import UserManagementPage from './pages/UserManagementPage/UserManagementPage';
import LoginPage from './pages/LoginPage/LoginPage';
import ProtectedRoute from './components/Auth/ProtectedRoute';

function App() {
  return (
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <ExerciseMainPage />
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <ExerciseMainPage />
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute>
              <UserManagementPage />
            </ProtectedRoute>
          } />
        </Routes>
      </Router> 
  );
}

export default App;
